/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  RewardsPoolMock,
  RewardsPoolMockInterface,
} from "../RewardsPoolMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "balanceOfToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "rewardAmount_",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "isSendRewardCalled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "maxBiome",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxNgLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "heroNgLevel",
        type: "uint256",
      },
    ],
    name: "lostProfitPercent",
    outputs: [
      {
        internalType: "uint256",
        name: "percent",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "maxBiome",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxNgLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "biome",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "heroNgLevel",
        type: "uint256",
      },
    ],
    name: "rewardAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "rewardAmount_",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "sendReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
    ],
    name: "setBalanceOfToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "maxBiome",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxNgLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "heroNgLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "percent",
        type: "uint256",
      },
    ],
    name: "setLostProfitPercent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "maxBiome",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxNgLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "biome",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "heroNgLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "setRewardAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class RewardsPoolMock__factory {
  static readonly abi = _abi;
  static createInterface(): RewardsPoolMockInterface {
    return new Interface(_abi) as RewardsPoolMockInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): RewardsPoolMock {
    return new Contract(address, _abi, runner) as unknown as RewardsPoolMock;
  }
}
